export const APP_OPENED = 'APP_OPENED';
export const APP_CLOSED = 'APP_CLOSED';
export const APP_INITIALIZATION_STARTED = 'APP_INITIALIZATION_STARTED';
export const APP_INITIALIZATION_SUCCEEDED = 'APP_INITIALIZATION_SUCCEEDED';
export const APP_INITIALIZATION_FAILED = 'APP_INITIALIZATION_FAILED';
export const APP_RELOADED = 'APP_RELOADED';

export const ROUTE_SET = 'ROUTE_SET';
export const ROUTE_SET_PREVENTED = 'ROUTE_SET_PREVENTED';

export const LANGUAGE_SET = 'LANGUAGE_SET';
export const CURRENCY_CHANGE_STARTED = 'CURRENCY_CHANGE_STARTED';
export const CURRENCY_CHANGE_SUCCEEDED = 'CURRENCY_CHANGE_SUCCEEDED';
export const CURRENCY_CHANGE_FAILED = 'CURRENCY_CHANGE_FAILED';

export const ANOTHER_HOTEL_SELECTED = 'ANOTHER_HOTEL_SELECTED';

export const IS_FX_MULTICURRENCY_SERVICE_ENABLED_SET = 'IS_FX_MULTICURRENCY_SERVICE_ENABLED_SET';
